import { Box, Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { proAccountThemeCoreUI as theme } from '../themes';

const StyledTypography = styled(Typography)(({ theme }) => ({
  lineHeight: '22px',
  fontWeight: '500',
  fontSize: '0.75rem',
  padding: '3px 8px',
  borderRadius: '4px',
  backgroundColor: theme.palette.grey[200],
  display: 'inline-block',
  whiteSpace: 'nowrap',
}));

export type ContainedTextProps = TypographyProps & {
  icon?: ReactNode;
};

/**
 * Props for configuring a contained text component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {ReactNode} icon - The icon to display in the component.
 *
 */
export const ContainedText = ({ ...props }: ContainedTextProps) => {
  const { icon, ...rest } = props;
  return (
    <>
      {icon ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
          }}
        >
          {icon}
          <StyledTypography {...rest} />
        </Box>
      ) : (
        <StyledTypography {...rest} />
      )}
    </>
  );
};
